// extracted by mini-css-extract-plugin
export var scale = "ExampleListingCard-module--scale--8e1b2";